module.exports = __webpack_public_path__ + "ic-redeem-points.svg?35d2073ee2da1b08fd870872b18a077e";